import { Cluster } from 'api/models';

const isExampleCluster = (c: Cluster) => {
  return /^example-cluster-ref/gm.test(c.internal_k8s_ref);
};

export default isExampleCluster;
